import createIcon from '../../createIcon';

/**
 * @component @name BedroomParent
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAxMkg3LjVDNi45NSAxMiA2LjUgMTIuNDUgNi41IDEzVjE0SDE3LjVWMTNDMTcuNSAxMi40NSAxNy4wNSAxMiAxNi41IDEyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjI1IDguNUg3LjI1VjEwLjVIMTEuMjVWOC41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2Ljc1IDguNUgxMi43NVYxMC41SDE2Ljc1VjguNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAySDRDMi45IDIgMiAyLjkgMiA0VjIwQzIgMjEuMSAyLjkgMjIgNCAyMkgyMEMyMS4xIDIyIDIyIDIxLjEgMjIgMjBWNEMyMiAyLjkgMjEuMSAyIDIwIDJaTTE5IDE3SDE3LjVWMTUuNUg2LjVWMTdINVYxMy4xN0M1IDEyLjUxIDUuMjUgMTEuOTEgNS42NSAxMS40NVY5QzUuNjUgNy45IDYuNTUgNyA3LjY1IDdIMTFDMTEuMzcgNyAxMS43MiA3LjEyIDEyIDcuMzJDMTIuMjggNy4xMiAxMi42MyA3IDEzIDdIMTYuMzVDMTcuNDUgNyAxOC4zNSA3LjkgMTguMzUgOVYxMS40NUMxOC43NSAxMS45MSAxOSAxMi41MSAxOSAxMy4xN1YxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BedroomParent = createIcon('BedroomParent', [
  [
    'path',
    {
      d: 'M16.5 12H7.5C6.95 12 6.5 12.45 6.5 13V14H17.5V13C17.5 12.45 17.05 12 16.5 12Z',
      key: 'ms5vfn',
    },
  ],
  ['path', { d: 'M11.25 8.5H7.25V10.5H11.25V8.5Z', key: 'byyv1z' }],
  ['path', { d: 'M16.75 8.5H12.75V10.5H16.75V8.5Z', key: '1sbmvk' }],
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM19 17H17.5V15.5H6.5V17H5V13.17C5 12.51 5.25 11.91 5.65 11.45V9C5.65 7.9 6.55 7 7.65 7H11C11.37 7 11.72 7.12 12 7.32C12.28 7.12 12.63 7 13 7H16.35C17.45 7 18.35 7.9 18.35 9V11.45C18.75 11.91 19 12.51 19 13.17V17Z',
      key: '11kdpx',
    },
  ],
]);

export default BedroomParent;
